module.exports = __webpack_public_path__ + "static/media/uttar_pradesh.6d07a762.png";